import { ApprovalTaskDefinition } from 'modules/inbox_tasks/tasks/approval'
import { ApprovalsV2TaskDefinition } from 'modules/inbox_tasks/tasks/approvalsv2'
import { EmployeeUpdateTaskDefinition } from 'modules/inbox_tasks/tasks/employeeUpdates'
import { FillDocumentTaskDefinition } from 'modules/inbox_tasks/tasks/fillDocument'
import { FillFormTaskDefinition } from 'modules/inbox_tasks/tasks/fillForm'
import { PeerAssignmentTaskDefinition } from 'modules/inbox_tasks/tasks/peerAssignment'
import { ReviewEvaluationTaskDefinition } from 'modules/inbox_tasks/tasks/reviewEvaluation'
import { SignatureTaskDefinition } from 'modules/inbox_tasks/tasks/signature'
import { UploadDocumentTaskDefinition } from 'modules/inbox_tasks/tasks/uploadDocument'
import { WorkflowHandlerExecutionTaskDefinition } from 'modules/inbox_tasks/tasks/workflows'

export const getTaskDefinitions = () => {
  const definitions = [
    ApprovalTaskDefinition,
    ApprovalsV2TaskDefinition,
    SignatureTaskDefinition,
    ReviewEvaluationTaskDefinition,
    FillDocumentTaskDefinition,
    PeerAssignmentTaskDefinition,
    EmployeeUpdateTaskDefinition,
    FillFormTaskDefinition,
    WorkflowHandlerExecutionTaskDefinition,
    UploadDocumentTaskDefinition,
  ]

  definitions.forEach((definition) => {
    const isValidDefinition =
      definition && typeof definition === 'object' && 'taskableTypename' in definition

    if (!isValidDefinition) {
      throw new Error(`Invalid task definition: ${definition}`)
    }
  })

  return definitions
}

type GetTaskDefinitionsResult = ReturnType<typeof getTaskDefinitions>

export type TaskDefinition = GetTaskDefinitionsResult[number]
